import { Point, TextStyle } from "pixi.js";
import { PiggyInfoType } from "./PiggyInfoType";
import { GameFont } from "../../../common/GameFont";

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 140,
            fill: [
                "00F7FF",
                '3481FF'
            ],
            fillGradientType: 1
        });
    }
}

class SmallHeaderTextStyle extends HeaderTextStyle {
    public constructor() {
        super();
        this.fontSize = 140;
    }
}

class InnerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.BEBAS_NEUE_PRO_SMERG_BOLD,
            fontSize: 64,
            lineHeight: 64,
            fill: 'FFFFFF',
            align: "center"
        });
    }
}

export type PiggyInfoViewDescription = {
    glassTexture: string;
    glassPosition: Point;
    iconTexture: string;
    iconPosition: Point;
    headerTextText: string;
    headerTextTextStyle: TextStyle;
    headerTextPosition: Point;
    innerTextText: string;
    innerTextTextStyle: TextStyle;
    innerTextPosition: Point;
    innerTextWidth: number;
    closeButtonPosition: Point;
}

export class PiggyInfoViewConfig {
    public static readonly VIEW_CONFIG = new Map<PiggyInfoType, PiggyInfoViewDescription>([
        [PiggyInfoType.PIGGY, {
            glassTexture: "assets_views_piggy_info_piggy_background_png",
            glassPosition: new Point(29, 379),
            iconTexture: "assets_views_piggy_info_piggy_icon_png",
            iconPosition: new Point(487, 83),
            headerTextText: "PIGGY BANK",
            headerTextTextStyle: new HeaderTextStyle(),
            headerTextPosition: new Point(35, 309),
            innerTextText: "Your Piggy Bank contains\nvarious benefits that you can\nunlock once you reach a\ncertain level.\n\nEach Piggy Bank unlocks\nwhen you achieve a new level\nby gaining upgrade points\nfrom upgrading items\nin your buildings.\n\nOnce you unlock a Piggy Bank,\na new one with additional\ncool benefits will be created\nfor you automatically.",
            innerTextTextStyle: new InnerTextStyle(),
            innerTextWidth: 701,
            innerTextPosition: new Point(80, 522),
            closeButtonPosition: new Point(374, 1606),
        }],
        [PiggyInfoType.TOKEN, {
            glassTexture: "assets_views_piggy_info_token_background_png",
            glassPosition: new Point(72, 638),
            iconTexture: "assets_views_piggy_info_token_png",
            iconPosition: new Point(597, 463),
            headerTextText: "OWN POINTS",
            headerTextTextStyle: new SmallHeaderTextStyle(),
            headerTextPosition: new Point(75, 544),
            innerTextText: "OWN Points can be used\nto upgrade items\nin your buildings and\nto earn dice rolls.",
            innerTextTextStyle: new InnerTextStyle(),
            innerTextWidth: 573,
            innerTextPosition: new Point(131, 869),
            closeButtonPosition: new Point(374, 1535),
        }],
        [PiggyInfoType.COUPON, {
            glassTexture: "assets_views_piggy_info_coupon_background_png",
            glassPosition: new Point(72, 420),
            iconTexture: "assets_views_piggy_info_coupon_png",
            iconPosition: new Point(477, 208),
            headerTextText: "COUPONS",
            headerTextTextStyle: new HeaderTextStyle(),
            headerTextPosition: new Point(72, 344),
            innerTextText: "Discount coupons\ncan be used for\npurchasing buildings in\nthe marketplace.\n\nLook for buildings with\nthe coupon icon in the\nmarketplace to receive\nthe specified discount\non the initial cost.\n\nYou need to use the\ncoupon\nbefore it expires.",
            innerTextTextStyle: new InnerTextStyle(),
            innerTextWidth: 599,
            innerTextPosition: new Point(160, 536),
            closeButtonPosition: new Point(374, 1586),
        }],
    ])
}